type GetOfferWarningTextArgs = {
  offerPrice: number;
  minimalOfferPrice: number;
  listingPrice: number;
  isNewOffer?: boolean;
};

export const getOfferWarningText = ({
  listingPrice,
  offerPrice,
  minimalOfferPrice,
  isNewOffer
}: GetOfferWarningTextArgs) => {
  if (offerPrice < minimalOfferPrice) {
    return isNewOffer
      ? 'You can only submit an offer \n within 30% of the listed price'
      : 'Offers must be at least 50% of \n the listed price';
  } else if (offerPrice > listingPrice) {
    return 'You can only submit an offer \n lower than the listed price';
  } else if (offerPrice === listingPrice) {
    return "Can't submit offer equal to the listed price. Order the item instead.";
  }
};
